import { CircularProgress, Grid, Typography, Skeleton, Box } from "@mui/material";

const TimeSlotsLoadingState = () => (
  <Box width="100%" maxWidth={900}>
    <Typography variant="body2" sx={{ mb: 1 }}>
      Please wait while we check court availability for your selected date
    </Typography>
    <CircularProgress size={18} sx={{ mb: 1 }}/>
    <Grid container spacing={2}>
      {Array.from({ length: 9 }).map((_, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Skeleton
            variant="rounded"
            height={48}
            animation="wave"
          />
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default TimeSlotsLoadingState;